export type SessionIds = {
  clientId: number | string | null;
  sessionId: number | string | null;
  session: any;
};

export const getSessionIds = (responseData: any): SessionIds => {
  const session = responseData?.session_data || responseData;
  return {
    clientId: responseData?.client?.id ?? session?.client?.id ?? session?.client_id ?? null,
    sessionId: session?.id ?? session?.session_id ?? null,
    session: responseData,
  };
};

export const normalizeBoolean = (value: unknown): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string")
    return value.toLowerCase() === "true" || value.toLowerCase() === "yes";
  return Boolean(value);
};

export const toNullableNumber = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isNaN(n) ? null : n;
};
